import { ReviewItemFieldsFragment } from "@api/graphql/types-and-hooks";

const AVATAR_COLOR_CLASSES = [
  "bg-emerald-500",
  "bg-amber-500",
  "bg-blurple-500",
  "bg-rose-500",
  "bg-sky-500",
  "bg-violet-500",
];

const UNKNOWN_USER_ID = "unknown-user";
const UNKNOWN_USER_NAME = "Unknown user";

const hashString = (value: string): number => {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

type ReviewUser = NonNullable<ReviewItemFieldsFragment["resolvedBy"]>;

export const getAvatarColorClass = (id: string): string =>
  AVATAR_COLOR_CLASSES[hashString(id) % AVATAR_COLOR_CLASSES.length];

export const getReviewUserDisplay = (user: ReviewUser | null): { name: string; initials: string } => {
  if (!user) return { name: UNKNOWN_USER_NAME, initials: UNKNOWN_USER_NAME.charAt(0) };
  const firstName = user.firstName.trim();
  const lastName = user.lastName?.trim() ?? "";
  const name = `${firstName} ${lastName}`.trim() || user.email?.trim() || UNKNOWN_USER_NAME;
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}` || name.charAt(0);
  return { name, initials: initials.toUpperCase() };
};

/** null = system/QA-generated row — only a ReportCommentType has a human author. */
export const getCommentAuthor = (
  item: ReviewItemFieldsFragment,
): { id: string; name: string; initials: string } | null => {
  if (item.__typename !== "ReportCommentType") return null;
  const id = item.author?.id ?? UNKNOWN_USER_ID;
  return { id, ...getReviewUserDisplay(item.author ?? null) };
};
